const CategoryOptions = [
  {
    category: 'Random',
    value: '',
  },
  {
    category: 'General knowledge',
    value: 9,
  },
  {
    category: 'Entertainment: Books',
    value: 10,
  },
  {
    category: 'Entertainment: Movies',
    value: 11,
  },
  {
    category: 'Entertainment: Music',
    value: 12,
  },
  {
    category: 'Entertainment: Musical & Theater',
    value: 13,
  },
  {
    category: 'Entertainment: Television',
    value: 14,
  },
  {
    category: 'Entertainment: Video Game',
    value: 15,
  },
  {
    category: 'Entertainment: Board Games',
    value: 16,
  },
  {
    category: 'Entertainment: Japanese Anime & Manga',
    value: 31,
  },
  {
    category: 'Entertainment: Cartoon & Animation',
    value: 32,
  },
  {
    category: 'Entertainment: Comics',
    value: 29,
  },
  {
    category: 'Science and Nature',
    value: 17,
  },
  {
    category: 'Science: Computers',
    value: 18,
  },
  {
    category: 'Science: Mathematics',
    value: 19,
  },
  {
    category: 'Science: Gadgets/Technology',
    value: 30,
  },
  {
    category: 'Mythology',
    value: 20,
  },
  {
    category: 'Sports',
    value: 21,
  },
  {
    category: 'Geography',
    value: 22,
  },
  {
    category: 'History',
    value: 23,
  },
  {
    category: 'Policy',
    value: 24,
  },
  {
    category: 'Art',
    value: 25,
  },
  {
    category: 'Celebrities',
    value: 26,
  },
  {
    category: 'Animal Kingdom',
    value: 27,
  },
  {
    category: 'Vehicles',
    value: 28,
  },
];

export default CategoryOptions;
